/**
 * Normalize shop / product-detail API objects → persisted wishlist row.
 * Keeps ids aligned with `/product-details/:id` (web product id).
 */
export function toWishlistPayload(product) {
    if (!product || typeof product !== 'object') return null

    const id = product.id ?? product.web_product_id
    if (id == null || id === '') return null

    const title = product.title || product.product_name || 'Product'

    let image = ''
    if (typeof product.image === 'string' && product.image) {
        image = product.image
    } else if (typeof product.image_url === 'string') {
        image = product.image_url
    } else if (typeof product.img === 'string') {
        image = product.img
    } else if (Array.isArray(product.images) && product.images.length) {
        const first = product.images[0]
        image =
            typeof first === 'string'
                ? first
                : first?.image_path || first?.url || ''
    }

    return {
        id,
        title,
        image,
        price: Number(product.price ?? product.web_price ?? 0),
        discount_percentage: Number(product.discount_percentage ?? 0),
        quantity: Number(product.quantity ?? product.total_quantity ?? 0),
    }
}
